
import React, { FC, useState, useEffect } from 'react'
import { KTSVG } from '../../../../_metronic/helpers'
import { useFormik, FormikProps } from 'formik'
import * as a from '../'

type Props = {
    colSpan?: number
    formik: FormikProps<any>
    fieldPropColumn?: string
    className?: string
    style?: any
}

export const THCheckbox: React.FC<Props> = ({ colSpan, formik, fieldPropColumn, className, style, children }) => {
    const [isChecked, setIsChecked] = useState<boolean>(false)

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
        for (let i = 0; i < formik.values.length; i++) {
            const item = formik.values[i];
            formik.setFieldValue(`[${i}].${fieldPropColumn}`, !isChecked);
        }
    }

    //useEffect(() => {
    //    for (let i = 0; i < formik.values.length; i++) {
    //        const item = formik.values[i];
    //        formik.setFieldValue(`[${i}].${fieldPropColumn}`, isChecked);
    //    }
    //}, [isChecked, formik.values])

    return (
        <th colSpan={colSpan != undefined ? colSpan : 1} role="columnheader" style={style} className={"pe-2 " + className}>
            <div className="form-check form-check-sm form-check-custom form-check-solid">
                <input className="form-check-input"
                    type="checkbox"
                    id={"chkTableSelect"}
                    checked={isChecked}
                    onChange={handleCheckboxChange} />
            </div>
        </th>
    )
}